import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApplicationAccessDenied() {
  return /*#__PURE__*/_jsx(Section, {
    use: "island",
    children: /*#__PURE__*/_jsx(TFlex, {
      justify: "around",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "600px",
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          illustration: "lock",
          illustrationProps: {
            width: 200
          },
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'disabledMessage.common.applicationAccessDenied.title'
          }),
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'disabledMessage.common.applicationAccessDenied.message'
            })
          })
        })
      })
    })
  });
}